// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qast","top":"styles_top__8WuVQ","left":"styles_left__12aVb","description":"styles_description__8Vrnv"};